import React from "react";
import InfoBox from '../components/info.js'
import ImageBas from './../../images/BP_N008041.jpg'
import Panoramic from "../components/panoramic.js";

export default () => (
    <Panoramic>
        <div className='metadata--wrapper'>
            <img src={ImageBas} alt="" />
            <InfoBox>Spectateurs au Palais Montcalm. Photographe inconnu, Fond Théo Genest (AVQ), ca1943.</InfoBox>
        </div>
    </Panoramic>
);



// WEBPACK FOOTER //
// ./src/components/image-footer-digestif.js